<script>
import {
  ABN_NUMBER_LENGTH,
  VAT_ID_ERROR_MESSAGE,
  VAT_ID_EU_NUMBER_MIN,
  VAT_ID_EU_NUMBER_MAX,
} from '@/constants';

export default {
  methods: {
    validateVatId() {
      this.$nextTick(() => {
        const { value } = this.$refs.vatId || {};
        this.$delete(this.errors, 'vat_id');
        this.$delete(this.notifications, 'vat_id');
        if (!value?.length) {
          return;
        }

        if (this.showAbn) {
          if (!this.$refs?.vatId?.validate || value?.length !== ABN_NUMBER_LENGTH) {
            this.$set(this.errors, 'vat_id', VAT_ID_ERROR_MESSAGE.ABN_LENGTH);
          } else if (this.isVatIdEstimationError && value?.length === ABN_NUMBER_LENGTH) {
            this.$set(this.notifications, 'vat_id', VAT_ID_ERROR_MESSAGE.ABN_NUMBER_INVALID);
          }
        }
        if (this.enabledEurovat) {
          if (
            !this.$refs?.vatId?.validate ||
            value?.length < VAT_ID_EU_NUMBER_MIN ||
            value?.length > VAT_ID_EU_NUMBER_MAX
          ) {
            this.$set(this.errors, 'vat_id', VAT_ID_ERROR_MESSAGE.VAT_ID_LENGTH);
          } else if (
            this.isVatIdEstimationError &&
            value?.length >= VAT_ID_EU_NUMBER_MIN &&
            value?.length <= VAT_ID_EU_NUMBER_MAX
          ) {
            this.$set(this.notifications, 'vat_id', VAT_ID_ERROR_MESSAGE.VAT_NUMBER_INVALID);
          }
        }
      });
    },
  },
};
</script>
